import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { IonicVue } from "@ionic/vue";
import { Network } from "@capacitor/network"

import firebase from 'firebase/app'
import 'firebase/firebase-messaging'
import firebaseConfig from "./configs/firebase-config.json";

import setProperties from "./plugins/vueProperties";
import Vue3NativeNotification from 'vue3-native-notification'

import "@firebase/auth";
import "@firebase/firestore";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import store from "./store";

Network.addListener('networkStatusChange', status => {
  document.dispatchEvent(
    new CustomEvent('swOffline', { detail: status })
  )
});

window.addEventListener("load", () => {
  if (navigator.onLine) {
    document.dispatchEvent(
      new CustomEvent('swOffline', { detail: { connected: true} })
    )
  } else {
    document.dispatchEvent(
      new CustomEvent('swOffline', { detail: { connected: false} })
    )
  }
});

if ("serviceWorker" in navigator && process.env.VUE_APP_LOCAL != 'true') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').then(registration => {
      console.info('[Service Worker] Registered: ', registration);
    }).catch(registrationError => {
      console.info('[Service Worker] Registration failed: ', registrationError);
    });
  });

  var refreshed;
  navigator.serviceWorker.addEventListener('controllerchange', (event) => {
    console.info('[Service Worker] Controller Change Service Worker -> refreshed', refreshed)
    if (refreshed) return;
      refreshed = true;
      window.location.reload(true);
    }
  );
}

const app = createApp(App);

app.use(store);
app.use(IonicVue);
app.use(Vue3NativeNotification, {requestOnNotify: true,})

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

//HABILITANDO CACHE DE REQUISIÇÕES DO FIREBASE PARA USO OFFLINE
firebase.firestore().enablePersistence()
  .then(() => {
    console.info('[Firestore] Enable Persistence')
  })
  .catch((err) => {
      if (err.code == 'failed-precondition') {
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
      } else if (err.code == 'unimplemented') {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
      }
  });

store.$isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
store.$appConfig = firebaseConfig;
store.$auth = firebase.auth;
store.$db = firebase.firestore;
store.$messaging = (firebase.messaging.isSupported()) ? firebase.messaging() : null;

// Gravando evento de instalação para criar botão instalação no ModalUser
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault()
  store.$deferredPrompt = e
  return false
});

/* Vue Properties */
setProperties();

const customRouter = router.initRouter()
store.$router = customRouter
app.use(customRouter)
customRouter.isReady().then(() => {
  app.mount("#app");
});